import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import About from "./Components/About";
import Events from "./Components/Events";
import Services from "./Components/Services";
import Vendors from "./Components/Vendors";
import Gallery from "./Components/Gallery";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
import CustomCursor from "./Components/CustomCursor";

import useCustomCursor from "./hooks/useCustomCursor";
import useReveal from "./hooks/useReveal";
import useNavbarScroll from "./hooks/useNavbarScroll";
import useParallax from "./hooks/useParallax";
import InstagramSection from "./Components/Create InstagramSection";
import PromiseByTeam from "./Components/PromiseByTeam";
import Affordable from "./Components/Affordable";

function App() {
  useCustomCursor();
  useReveal();
  useNavbarScroll();
  useParallax();

  return (
    <>
      <CustomCursor />
      <Navbar />
      <Hero />
      <div class="marquee-bar">
  <div class="marquee-track">
    <span class="marquee-item">Weddings <span class="marquee-dot"></span></span>
    <span class="marquee-item">Birthdays <span class="marquee-dot"></span></span>
    <span class="marquee-item">Engagements <span class="marquee-dot"></span></span>
    <span class="marquee-item">Corporate Events <span class="marquee-dot"></span></span>
    <span class="marquee-item">Baby Showers <span class="marquee-dot"></span></span>
    <span class="marquee-item">Naming Ceremonies <span class="marquee-dot"></span></span>
    <span class="marquee-item">Puberty Ceremonies <span class="marquee-dot"></span></span>
    <span class="marquee-item">Anniversary Parties <span class="marquee-dot"></span></span>
    <span class="marquee-item">Housewarming <span class="marquee-dot"></span></span>
    <span class="marquee-item">Farewell Events <span class="marquee-dot"></span></span>
    <span class="marquee-item">Weddings <span class="marquee-dot"></span></span>
    <span class="marquee-item">Birthdays <span class="marquee-dot"></span></span>
    <span class="marquee-item">Engagements <span class="marquee-dot"></span></span>
    <span class="marquee-item">Corporate Events <span class="marquee-dot"></span></span>
    <span class="marquee-item">Baby Showers <span class="marquee-dot"></span></span>
    <span class="marquee-item">Naming Ceremonies <span class="marquee-dot"></span></span>
    <span class="marquee-item">Puberty Ceremonies <span class="marquee-dot"></span></span>
    <span class="marquee-item">Anniversary Parties <span class="marquee-dot"></span></span>
    <span class="marquee-item">Housewarming <span class="marquee-dot"></span></span>
    <span class="marquee-item">Farewell Events <span class="marquee-dot"></span></span>
  </div>
</div>
      <InstagramSection />
      <About />
      <Events />
      <Services />
      <PromiseByTeam />
      <Affordable />
       <Gallery />
      <Vendors />
     
      <Contact />
      <Footer />
    </>
  );
}

export default App;